import React, { useState, useCallback } from "react";
import {
  addDoc,
  collection,
  doc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db, auth } from "../api/firebase";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { useNotification } from "../redux/useNotification";

import {
  Box,
  Stack,
  Typography,
  Button,
  Alert,
  CircularProgress,
  Divider,
} from "@mui/material";

const FeedPrivate = ({ setOpen, requestId, target, onDone }) => {
  const { displayNotification } = useNotification();

  const [data, setData] = useState({
    error: null,
    loading: false,
  });
  const { error, loading } = data;

  // user は現状使ってないので消してOK（必要なら復活）
  useDocumentData(doc(db, "users", auth.currentUser.uid));

  const handleClose = useCallback(() => {
    if (loading) return; // 連打防止
    setOpen(false);
  }, [loading, setOpen]);

  const handleSubmit = useCallback(async () => {
    if (!requestId || !auth.currentUser?.uid) return;

    setData({ error: null, loading: true });

    try {
      await updateDoc(doc(db, "post", requestId), {
        isPublish: false,
        updatedAt: serverTimestamp(),
        updatorId: auth.currentUser.uid,
        reason: "feedPrivate",
        component: "FeedPrivate.js",
      });

      displayNotification({
        message: "投稿を非表示にしました。",
        type: "success",
      });

      onDone?.(); // 親に成功通知（投稿カード即消し）
      setOpen(false);
      setData({ error: null, loading: false });
    } catch (err) {
      console.log("err =>", err);

      displayNotification({
        message: "非表示に失敗しました。通信状況をご確認ください。",
        type: "error",
      });

      setData({ error: err?.message || "unknown error", loading: false });

      const errorData = { message: err?.message, stack: err?.stack };
      addDoc(collection(db, "error"), {
        createdAt: serverTimestamp(),
        error: errorData,
        component: "FeedPrivate.js",
      });
    }
  }, [requestId, displayNotification, onDone, setOpen]);

  return (
    <Box>
      <Stack spacing={2}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          投稿を非表示にしますか？
        </Typography>

        <Typography variant="body2" color="text.secondary">
          この投稿はフィード上に表示されなくなります。
        </Typography>

        <Alert severity="warning">
          この操作は取り消せません。内容をご確認のうえ実行してください。
        </Alert>

        {error ? (
          <Alert severity="error">
            {String(error)}
          </Alert>
        ) : null}

        <Divider />

        <Stack direction="row" spacing={1.5} justifyContent="flex-end">
          <Button onClick={handleClose} disabled={loading} color="inherit">
            キャンセル
          </Button>

          <Button
            onClick={handleSubmit}
            disabled={loading}
            variant="contained"
          >
            {loading ? (
              <Stack direction="row" spacing={1} alignItems="center">
                <CircularProgress size={18} />
                <span>処理中...</span>
              </Stack>
            ) : (
              "非表示にする"
            )}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default FeedPrivate;
